import { render, staticRenderFns } from "./list04.vue?vue&type=template&id=01e2e7b7&"
import script from "./list04.vue?vue&type=script&lang=js&"
export * from "./list04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports